import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import * as React from 'react';

import styles from './Select.module.css';

export default function SelectVariants({
  name,
  field,
  setField,
  options,
  defaultValue,
  withLabel = true,
  small = false,
}) {
  const style = small ? styles.labelSmall : styles.label;

  const handleChange = (event) => {
    setField(event.target.value);
  };

  return (
    <div>
      <FormControl variant="standard" sx={{ m: 1, minWidth: 80, maxWidth: 150 }}>
        {withLabel && <InputLabel id={name}>{name}</InputLabel>}
        <Select
          defaultValue={defaultValue}
          value={field}
          onChange={handleChange}
          label={name}
          autoFocus={false}
          MenuProps={{
            autoFocus: false,
            disableAutoFocusItem: true,
            disableEnforceFocus: true,
            disableAutoFocus: true,
            sx: {
              height: '500px'
            }
          }}
        >
          {options.map((o) => (
            <MenuItem value={o.value}>
              <span className={style}>{o.label}</span>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
